import { api } from '@/lib/api';

export const hospitalsService = {
  async getRoleModules() {
    const { data } = await api.get('/hospitals/role-modules');
    return { data };
  },

  async updateRoleModules(roleModuleAccess) {
    const { data } = await api.patch('/hospitals/role-modules', {
      roleModuleAccess,
    });
    return { data };
  },

  async createCustomRole(body) {
    const { data } = await api.post('/hospitals/custom-roles', body);
    return { data };
  },

  async updateCustomRole(roleKey, body) {
    const { data } = await api.patch(
      `/hospitals/custom-roles/${encodeURIComponent(roleKey)}`,
      body,
    );
    return { data };
  },

  async deleteCustomRole(roleKey) {
    const { data } = await api.delete(
      `/hospitals/custom-roles/${encodeURIComponent(roleKey)}`,
    );
    return { data };
  },
};
